import React, { useEffect, useState } from 'react'

import ReusableDiv from 'src/helper/ReusableDiv';
import TaxExempt from './TaxExempt';
import System from 'src/helper/system';
import Constants from 'src/helper/Constants';
import { profileStore } from 'src/hooks/profile';
import useReduxState from 'src/hooks/useReduxState';
import { useOrderStore } from 'src/hooks/order';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Helper from 'src/helper/Helper';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import { useCartStore } from 'src/hooks/cart';
import { Beacon } from 'src/component/Global/Beacon';
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import HelperAdobeEvent from 'src/support/HelperAdobeEvent';

const CheckoutShippingMethod = () => {
    const { shippingAddressType: { Type: { DOMESTIC, INTERNATIONAL, CANADA } }, siteUser, avnetCarrierType: { FEDEX, UPS, DHL }, shippingCarrierType: { MANUAL, AVNET, FREESHIP }, checkOutSteps: { METHOD_STEP, PAYMENT_STEP }, taxExempt: { NONE } } = Constants
    const [{ billing_addresses, shipping_addresses, all_carriers }, { }, { set_account_address_default }] = profileStore()
    const [__check] = useAxiosIndicatorCheck();
    const isCoreUser = System.avUserInfoData.currentUser === siteUser.CORE
    const [{ validate_order_from_server }, { }, { place_your_order }] = useOrderStore()
    const [shippingAddressInfo,] = useReduxState({}, 'setShippingAddressInfo')
    const [userrAddressType, setUserrAddressType] = useState("")
    const [complianceValue, setComplianceValue] = useReduxState('', 'setComplianceValue')
    const [exportCompliance, setExportCompliance] = useState(false)
    const [selectedAvnetCarrier, setSelectedAvnetCarrier] = useState('')
    const [isEdit, setIsEdit] = useState(false);
    const [errors, setErrors] = useState({ accountNumber: '', carrierOption: '', complianceOption: '' })
    const [shippingMethodInfo, setShippingMethodInfo] = useReduxState({}, 'setShippingMethodInfo')
    const [checkOutStepStatus, setCheckoutStepStatus] = useReduxState('', 'setCheckoutStepStatus')
    const [exportComplianceStatus, setExportComplianceStatus] = useReduxState(false, 'setExportComplianceStatus')
    const [{ }, { system_alert_indicator, remove_system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    const [{ CART_DATA, CART_PRODUCTS }, { }, { add_compliance_data }] = useCartStore();
    const [hazardousFlag, setHazardousFlag] = useState(false)
    const [disabled, disable] = useReduxState(false, "disable");
    const [shipOnlyWhenAvailable, setShipOnlyWhenAvailable] = useReduxState(false, "setShipOnlyWhenAvailable");
    const [taxExemptDetails, setTaxExemptDetails] = useReduxState({ taxExemptFile: '', taxExempt: NONE }, "setTaxExemptDetails");
    const isOnlySoftwareParts = CART_PRODUCTS && !Object.values(CART_PRODUCTS).some(f => f.SoftwareDownloadFlag === false);
    const [{ }, { get_inventory_by_id }, { }] = useProductInventoryPriceStore();
    const freeShipObject = {
        carrierType: FREESHIP,
        value: 0
    }

    useEffect(() => {
        let addressType = System.getUserAddressType(shipping_addresses, shippingAddressInfo?.id)?.shippingType;
        setUserrAddressType(addressType)
        if (CART_PRODUCTS && Object.values(CART_PRODUCTS)?.length > 0) {
            const ishazardious = Object.values(CART_PRODUCTS).find(f => f.HazardousFlag === true && userrAddressType == DOMESTIC)
            if (ishazardious) {
                setHazardousFlag(true);
            } else {
                setHazardousFlag(false);
            }
        }
    }, [CART_DATA, shippingAddressInfo?.id])

    function findDefaultShipMethod() {
        const { defaultId, fedEx = [], dhl = [], ups = [], intl = [], dom = [] } = all_carriers;
        let manualCarriers = userrAddressType === DOMESTIC ? dom : intl
        let allCarriers = [...fedEx, ...dhl, ...ups, ...manualCarriers];
        return allCarriers.find(carrier => carrier.id === defaultId);
    }

    useEffect(() => {
        setErrors({ accountNumber: '', carrierOption: '', complianceOption: '' })
        const defaultShipMethod = findDefaultShipMethod(all_carriers);
        if (defaultShipMethod) {
            setShippingMethodInfo({
                ...defaultShipMethod,
                carrierAccount: all_carriers?.carrierAccount,
                carrierType: defaultShipMethod?.carrierType
            });
        } else {
            // handle case for freeship selection for core user
            if (isCoreUser && all_carriers.isSAPCustomer && !shippingMethodInfo?.carrierType) {
                setShippingMethodInfo(freeShipObject)
            }
        }
    }, [all_carriers])

    useEffect(() => {
        if (shippingMethodInfo?.carrierType === AVNET) {
            const allAvnetCarriers = [...all_carriers?.fedEx, ...all_carriers?.ups, ...all_carriers?.dhl];
            if (shippingMethodInfo?.carrierKey) {
                setSelectedAvnetCarrier(shippingMethodInfo?.carrierKey == "FedEx" ? FEDEX : Helper.toLowerCase(shippingMethodInfo?.carrierKey));
            } else {
                setSelectedAvnetCarrier(allAvnetCarriers[0]?.carrierKey == "FedEx" ? FEDEX : Helper.toLowerCase(allAvnetCarriers[0]?.carrierKey));
            }
            if (allAvnetCarriers.length === 1) {
                setShippingMethodInfo(allAvnetCarriers[0]);
            }
        }

    }, [shippingMethodInfo?.carrierType])

    useEffect(() => {
        disable(validate_order_from_server?.shippingPerference)
        if (userrAddressType === DOMESTIC) {
            setExportCompliance(validate_order_from_server?.exportCompliance)
        }
    }, [validate_order_from_server])

    const ShippingMethodCallback = async (data = null) => {
        if (data) {
            await set_account_address_default(data)
        }
        // Submit form or perform the necessary action
        const { id, ...shippingMethodWithoutId } = shippingMethodInfo;
        let params = {
            billTo: billing_addresses[0]?.id || null,
            shipToId: shippingAddressInfo && shippingAddressInfo.id ? shippingAddressInfo.id : '',
            attn: shippingAddressInfo?.attn?.trim() ? shippingAddressInfo.attn?.trim() : '',
            SoftwareDownloadEmail: shippingAddressInfo?.SoftwareDownloadEmail?.trim() ? shippingAddressInfo.SoftwareDownloadEmail?.trim() : '',
            telephoneNumber: shippingAddressInfo?.telephoneNumber?.trim() ? shippingAddressInfo.telephoneNumber?.trim() : '',
            carrier: isOnlySoftwareParts ? null : shippingMethodWithoutId,
            orderPlaced: false,
            shippingPreference: shipOnlyWhenAvailable,
            taxExempt: taxExemptDetails?.taxExempt,
            taxExemptFileName: taxExemptDetails?.taxExemptFile
        }
        let plcOrd = await place_your_order(params);
        checkOutStep2();
        setIsEdit(false)
        setCheckoutStepStatus(PAYMENT_STEP)
    }

     function checkOutStep2(){
         localStorage.setItem("adobeEventType","checkOut");
         let checkOutStep = "checkoutStep2";
         let cartData = [];
         Object.entries(CART_DATA).map((data,key)=>{
            cartData.push(data[1])
        })
        cartData.forEach((data, key) => {
            let copyObj = { ...data };
            copyObj.qas = get_inventory_by_id(copyObj.ItemNumber || copyObj.itemNumber)?.inventoryQty || copyObj.quantity;
            cartData[key] = copyObj;
          })
        HelperAdobeEvent.trackingAdobeEvent({ prodDetails: cartData, stepType: checkOutStep, cartData: 'Checkout' });
     }
    const ExportComplienceCallBack = async (data = null) => {
        let isValid = true

        if (data) {
            isValid = false
            try {
                const complianceData = await add_compliance_data(data)
                if (complianceData?.isSuccessFull) {
                    setExportComplianceStatus(true)
                }
            } catch (error) {
            }
            isValid = true
        }
        if (isOnlySoftwareParts ? false : (shippingMethodInfo.carrierType != FREESHIP && all_carriers.defaultId !== shippingMethodInfo.id && isValid)) {
            System.popup("SaveShippingMethod", { shipData: shippingMethodInfo, ShippingMethodCallback })
        } else {
            ShippingMethodCallback()
        }
    }

    const handleContinue = () => {
        let isValid = onValidateData();

        if (isValid) {
            if (complianceValue !== "yes" && userrAddressType === DOMESTIC && exportCompliance) {
                ExportComplienceCallBack();
            } else if (userrAddressType === DOMESTIC && !exportCompliance) {
                ExportComplienceCallBack();
            } else {
                if (!exportComplianceStatus) {
                    System.popup('ExportCompliance', { ExportComplienceCallBack });
                } else {
                    if (isOnlySoftwareParts ? false : (shippingMethodInfo.carrierType != FREESHIP && all_carriers.defaultId !== shippingMethodInfo.id)) {
                        System.popup("SaveShippingMethod", { shipData: shippingMethodInfo, ShippingMethodCallback })
                    } else {
                        ShippingMethodCallback()
                    }
                }
            }
        }
    }
    // select Freeship,Manual,Avnet
    const handleChange = async (value) => {
        if (shippingAddressInfo?.address?.countryCode) {

            setShippingMethodInfo(value === FREESHIP ? freeShipObject : {
                carrierCountry: '',
                carrierKey: '',
                carrierOption: '',
                carrierService: '',
                currency: '',
                value: 0,
                isIntl: '',
                carrierType: value,
                carrierAccount: '',
                id: ''
            })
        }
    };
    // select option for MANUAL carrier change
    const handleCarrierChange = (field, field_value, options) => {
        if (field === 'carrierOption') {
            const selectedOption = options.find((item) => item.id == field_value);
            setShippingMethodInfo({
                ...shippingMethodInfo,
                carrierCountry: selectedOption?.carrierCountry || '',
                carrierKey: selectedOption?.carrierKey,
                carrierOption: selectedOption?.carrierOption || '',
                carrierService: selectedOption?.carrierService || '',
                currency: selectedOption?.currency || '',
                value: selectedOption?.value || 0,
                isIntl: selectedOption?.isIntl || '',
                carrierType: selectedOption?.carrierType || MANUAL,
                codeDescription: selectedOption?.codeDescription || '',
                id: selectedOption?.id || ''
            });
        } else {
            setShippingMethodInfo({ ...shippingMethodInfo, [field]: field_value })
        }
    };
    // select option of avnet carriers(FEDEX,UPS,DHL)
    const handleAvnetCarrierChange = (carrier) => {
        setShippingMethodInfo({
            ...shippingMethodInfo,
            carrierCountry: carrier.carrierCountry,
            carrierKey: carrier.carrierKey,
            carrierOption: carrier.carrierOption,
            carrierService: carrier.carrierService,
            currency: carrier.currency,
            value: carrier.value,
            isIntl: carrier.isIntl,
            id: carrier.id,
            carrierType: carrier.carrierType,
            codeDescription: carrier.codeDescription,
        });
    };
    // change the lable of avnet carrier
    const changeAvnetCarrier = (avnetCarrier) => {
        setSelectedAvnetCarrier(avnetCarrier)
    }
    const validateAccountNumber = (carrier, accountNumber) => {
        if (!accountNumber?.length) {
            return 'Please enter a carrier account number';
        } else {
            switch (carrier) {
                case 'UPS':
                    // Length must be exactly 6 alphanumeric characters
                    return Helper.validateRegex(accountNumber, /^[a-zA-Z0-9]{6}$/) ? '' : 'Invalid account number';
                case 'DHL':
                    // Starts with 95 or 96 followed by up to 13 alphanumeric characters
                    return Helper.validateRegex(accountNumber, /^(95|96)[a-zA-Z0-9]{0,13}$/) ? '' : 'Invalid account number';
                case 'FedEx':
                    // Length must be exactly 9 digits and valid check digit
                    return (accountNumber.length === 9 && Helper.validateRegex(accountNumber, /^\d{9}$/) && Helper.validateRegex(accountNumber, /^\d+$/)) ? '' : 'Invalid account number';
                default:
                    return (accountNumber.length <= 15 && accountNumber.length !== 0) ? '' : 'Invalid account number';
            }
        }
    }
    const onValidateData = () => {
        let validationModal = {};
        // Validate carrier details
        if (shippingMethodInfo?.carrierType === MANUAL) {
            if (shippingMethodInfo?.carrierOption === '') {
                validationModal.carrierOption = 'Please select a carrier option';
            }

            let accountValidationMessage = validateAccountNumber(shippingMethodInfo?.carrierKey, shippingMethodInfo?.carrierAccount);
            if (accountValidationMessage) {
                validationModal.accountNumber = accountValidationMessage;
            }
        } else if (shippingMethodInfo.carrierType === AVNET) {
            if (Helper.toLowerCase(selectedAvnetCarrier?.trim()) === Helper.toLowerCase(shippingMethodInfo?.carrierKey?.trim())) {
                if (shippingMethodInfo.carrierOption === '') {
                    validationModal.carrierOption = 'Please select a carrier option';
                }
            } else {
                validationModal.carrierOption = 'Please select a carrier option';
            }
        }
        if (validationModal.carrierOption) {
            system_alert_indicator({
                name: 'carrierOptionAlert',
                message: validationModal.carrierOption,
                type: "danger",
                isDisplay: false,
                isDisplayIcon: true,
            })
        } else {
            remove_system_alert_indicator('carrierOptionAlert')
        }


        setErrors(validationModal);
        return Object.keys(validationModal).length === 0;
    };

    const shouldRenderCarrier = (carrier) => {
        return (
            (userrAddressType === DOMESTIC && hazardousFlag === true && Helper.toLowerCase(carrier?.carrierService?.trim()).includes('ground')) ||
            (userrAddressType === DOMESTIC && hazardousFlag === false) ||
            (userrAddressType !== DOMESTIC)
        );
    };

    const renderCarriers = (carriers) => {
        return carriers.map((carrier) => (
            shouldRenderCarrier(carrier) && (
                <li key={carrier.id}>
                    <div className="form-check mb-1">
                        <input
                            className="form-check-input mt-1"
                            type="radio"
                            name="avtcarrier"
                            id={`avtcarrier${carrier.id}`}
                            value={carrier.carrierOption}
                            checked={carrier.carrierOption === shippingMethodInfo?.carrierOption}
                            onChange={() => handleAvnetCarrierChange(carrier)}
                        />
                        <label className="form-check-label" htmlFor={`avtcarrier${carrier.id}`}>
                            {carrier.carrierOption}
                        </label>
                    </div>
                </li>
            )
        ));
    }
    return (
        <div className={"shipping-address steps-inner mb-3 " +
            ((checkOutStepStatus === METHOD_STEP) ? 'active' : '') +
            ((checkOutStepStatus === PAYMENT_STEP) && !isEdit ? 'active completed' : '') +
            ((checkOutStepStatus === PAYMENT_STEP) && isEdit ? 'active' : '')}>
            <div className="checkout-titles d-flex justify-content-between"><h2>2. Shipping Method</h2> {((checkOutStepStatus === PAYMENT_STEP)) && <a className='text-white' onClick={() => { setIsEdit(true); setCheckoutStepStatus(METHOD_STEP) }} >Change </a>}</div>
            <div className='checkbox-steps-content'>
                <div className="step-complete-hide">
                    <div className="bs5 row">
                        {!isOnlySoftwareParts ? <>
                            <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <h3 className='mt-0'>SHIPPING METHOD OPTIONS:</h3>
                                {all_carriers?.isSAPCustomer === true && isCoreUser && <div className="form-check mb-2">
                                    <input className="form-check-input mt-1" type="radio" name="shippingMethod" id="FreeShip" value="FreeShip" checked={shippingMethodInfo.carrierType === FREESHIP}
                                        onChange={() => handleChange(FREESHIP)} />
                                    <label className="form-check-label text-darkgreen" htmlFor="FreeShip">
                                        <strong className='text-darkgreen'>Free Shipping</strong>
                                    </label>
                                </div>}

                                <div className='mycarrieraccount'>
                                    <div className="form-check mb-2">
                                        <input className="form-check-input mt-1" type="radio" name="shippingMethod" id="MANUAL"
                                            value={MANUAL}
                                            checked={shippingMethodInfo.carrierType === MANUAL}
                                            onChange={() => handleChange(MANUAL)} />
                                        <label className="form-check-label" htmlFor="MANUAL">
                                            Use My Carrier Account
                                        </label>
                                    </div>

                                    {shippingMethodInfo.carrierType === MANUAL && <div className='ms-3 ps-1'>
                                        <div className="mb-2">
                                            <label htmlFor="accountNumber" className="form-label" >Carrier Account Number*</label>
                                            <input type="text" className="form-control" id="accountNumber" placeholder="Carrier Account Number" value={shippingMethodInfo?.carrierAccount} onChange={(e) => handleCarrierChange('carrierAccount', e.target.value)} />
                                            {errors.accountNumber && <p className="error">{errors.accountNumber}</p>}
                                        </div>
                                        <div className="mb-2">
                                            <div className="mb-2">
                                                <label htmlFor="carrierMethod" className="form-label">Select Carrier Method*</label>
                                                {userrAddressType === DOMESTIC && <div>
                                                    <select className="form-control" id="carrierMethod" value={shippingMethodInfo?.id} onChange={(e) => {
                                                        handleCarrierChange('carrierOption', e.target.value, all_carriers?.dom);
                                                    }}>
                                                        <option value="" defaultValue>Select Carrier Method</option>

                                                        {all_carriers?.dom?.map((carrier) => (
                                                            <option key={carrier.id} value={carrier.id}>{carrier.carrierOption}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                }
                                                {(userrAddressType === INTERNATIONAL || userrAddressType === CANADA) &&
                                                    <div>
                                                        <select className="form-control" id="carrierMethod" value={shippingMethodInfo?.id} onChange={(e) => {
                                                            handleCarrierChange('carrierOption', e.target.value, all_carriers?.intl);
                                                        }}>
                                                            <option value="" defaultValue>Select Carrier Method</option>
                                                            {all_carriers?.intl?.map((carrier) => (
                                                                <option key={carrier.id} value={carrier.id}>{carrier.carrierOption}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                }
                                            </div>

                                        </div>
                                    </div>}
                                </div>

                                <div className='avnetcarrier mb-3'>
                                    <div className="form-check mb-2">
                                        <input className="form-check-input mt-1" type="radio" name="shippingMethod"
                                            id="AVNET"
                                            value={AVNET}
                                            checked={shippingMethodInfo.carrierType === AVNET}
                                            onChange={() => handleChange(AVNET)} />
                                        <label className="form-check-label" htmlFor="AVNET">
                                            Use Avnet’s Carrier Options
                                        </label>
                                    </div>
                                    {shippingMethodInfo.carrierType === AVNET && <div className='avnetcarrierselection'>
                                        <div className='d-flex'>
                                            {all_carriers?.fedEx?.length > 0 && <button
                                                className={`bs5 btn ${selectedAvnetCarrier === FEDEX ? "btn-primary" : "btn-secondary"} me-2`}
                                                onClick={() => changeAvnetCarrier(FEDEX)}
                                            >
                                                FEDEX
                                            </button>}
                                            {all_carriers?.dhl?.length > 0 && <button
                                                className={`bs5 btn ${selectedAvnetCarrier === DHL ? "btn-primary" : "btn-secondary"} me-2`}
                                                onClick={() => changeAvnetCarrier(DHL)}
                                            >
                                                DHL
                                            </button>}
                                            {all_carriers?.ups?.length > 0 && <button
                                                className={`bs5 btn ${selectedAvnetCarrier === UPS ? "btn-primary" : "btn-secondary"}`}
                                                onClick={() => changeAvnetCarrier(UPS)}
                                            >
                                                UPS
                                            </button>}
                                        </div>

                                        <ul className='mx-0 px-0 mt-3'>
                                            {selectedAvnetCarrier === FEDEX && renderCarriers(all_carriers.fedEx)}
                                            {selectedAvnetCarrier === UPS && renderCarriers(all_carriers.ups)}
                                            {selectedAvnetCarrier === DHL && renderCarriers(all_carriers.dhl)}
                                        </ul>

                                    </div>}
                                </div>

                                <hr></hr>
                                <div className="mb-3">
                                    <h3 className="mt-0">SHIPPING preferences:</h3>
                                    <p className='font-13 font-arial mb-0'><strong> Items will be shipped when they become available.</strong></p>
                                    <p className='mt-0'>Additional freight charges may apply for multiple shipments.</p>

                                    <div className="form-check mb-1 mt-3">
                                        <input disabled={disabled} className="form-check-input mt-1 " type="checkbox"
                                            name="shipre" id="shipre1"
                                            checked={shipOnlyWhenAvailable}
                                            onChange={(event) => {
                                                setShipOnlyWhenAvailable(event.target.checked);
                                            }} />
                                        <label className="form-check-label" htmlFor="shipre1">
                                            <b>
                                                Ship only when all items become available
                                            </b>
                                        </label>
                                        <br />
                                        <i>(backorder items may delay order)</i>
                                    </div>
                                </div>
                            </div>
                            {(validate_order_from_server?.message?.countryTariff || validate_order_from_server?.message?.internationalNewArk) && ReusableDiv.shippDetail({
                                countryTariff: validate_order_from_server?.message?.countryTariff,
                                internationalNewArk: validate_order_from_server?.message?.internationalNewArk
                            })}</> : <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"><b>Order Contains only Software items.</b></div>}
                        <TaxExempt />
                        {userrAddressType === DOMESTIC && exportCompliance &&
                            <div className='col-12 tax-exempt position-relative step-complete-hide'>
                                <hr className='mt-0'></hr>
                                <h3 className="mt-0">Export Compliance:</h3>
                                <p>Do you have any intention on exporting any items within this order?</p>

                                <ul className='mx-0 px-0 d-flex justify-content-left'>
                                    <li>
                                        <div className="form-check mb-1 me-3 d-flex justify-content-between align-items-center">
                                            <input className="form-check-input mt-1" type="radio" name="exportCompliance" id="avtcarrier1" checked={complianceValue === 'yes'} value="yes" onChange={(e) => { setComplianceValue(e.target.value); setErrors(prevState => ({ ...prevState, complianceOption: '' })); }} />
                                            <label className="form-check-label" htmlFor="avtcarrier1">
                                                Yes
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-check mb-1 d-flex justify-content-between align-items-center">
                                            <input className="form-check-input mt-1" type="radio" name="exportCompliance" id="avtcarrier2" checked={complianceValue === 'no'} value="no" onChange={(e) => { setComplianceValue(e.target.value); setErrors(prevState => ({ ...prevState, complianceOption: '' })); }} />
                                            <label className="form-check-label" htmlFor="avtcarrier2">
                                                No
                                            </label>
                                        </div>
                                    </li>
                                </ul>
                                {errors.complianceOption && <p className="error">{errors.complianceOption}</p>}
                            </div>
                        }

                        <div className="col-12 text-end mt-4 step-complete-hide">
                            {(userrAddressType === INTERNATIONAL || userrAddressType === CANADA || complianceValue === 'yes' || (exportCompliance && complianceValue === 'yes')) && <b className='d-block mb-2'>Export Compliance Required</b>}
                            <Beacon position={"right"} content={() => "If you uploaded a tax exempt certificate, your order may be taxed initially but you will receive credit once the tax document has been approved."}
                                opener={() => (
                                    <button type="submit" className="bs5 btn btn-primary btn-sm w130" disabled={(isOnlySoftwareParts ? false : shippingMethodInfo.carrierType == undefined || shippingMethodInfo.carrierType == '') || (userrAddressType === DOMESTIC && exportCompliance && !complianceValue)} onClick={handleContinue}>Continue</button>

                                )} />
                        </div>
                    </div>
                </div>

                <div className="step-complete-show">
                    {isOnlySoftwareParts ? <div className="mb-3"><b>Order Contains only Software items.</b></div> : <><div className="mb-3">
                        <h3 className="mt-0">SHIPPING METHOD OPTIONS:</h3>
                        {shippingMethodInfo?.carrierType === 'FreeShip' ?
                            <p className='font-13 font-arial'><strong> Free Shipping</strong></p> :
                            <div>
                                <span className='font-13 font-arial me-5'><strong> {shippingMethodInfo?.carrierKey}</strong></span>
                                <span className='font-13 font-arial'>{shippingMethodInfo?.carrierOption}</span>
                            </div>
                        }
                    </div>
                        <hr></hr>
                        <div className="mb-3">
                            <h3 className="mt-0">SHIPPING preferences:</h3>
                            {shipOnlyWhenAvailable ?
                                <p className='font-13 font-arial'>Combine all items into one shipment</p>
                                :
                                <>
                                    <p className='font-13 font-arial'><strong> Ship items as they become available</strong></p>
                                    <p className='mt-0'>(Additional freight charges may apply for multiple shipments)</p>
                                </>
                            }
                        </div>
                    </>}
                </div>
            </div>
        </div>
    );
}

export default CheckoutShippingMethod;